import { firebaseSelector, userIdSelector } from './baseSelectors'
import { createSelector } from 'reselect'
import { getVal, populate } from 'react-redux-firebase'
import populates from '../populates'

export const activityShowingSelector = state => state.activity.show
export const activityFilterSelector = state => state.activity.filter

export const unreadActivityCountSelector = createSelector(
  [userIdSelector, firebaseSelector],
  (userId, firebase) =>
    getVal(firebase, `activity/feeds/${userId}/unreadCount`, 0)
)

export const _activitySelector = createSelector(
  [userIdSelector, state => state.firebase],
  (userId, firebase) =>
    populate(firebase, `activity/feeds/${userId}/feed`, [
      populates.userName,
      populates.boardName
    ])
)
export const activitySelector = createSelector(
  [_activitySelector, activityFilterSelector],
  (activity, filter) => {
    if (!activity) return activity

    activity = Object.values(activity)
    if (filter === 'unread') activity = activity.filter(a => !a.read)
    // newest first
    return activity.sort((a, b) => b.date - a.date)
  }
)
